import { useIntl } from 'react-intl'
import styled from 'styled-components'
import { rem } from 'polished'
import { useDrawerAskAI } from 'tripPlanner/pages/chat/ChatTripPlannerPage/hooks/useDrawerAskAI'
import { useDrawerAskAIChatState } from 'tripPlanner/pages/chat/ChatTripPlannerPage/contexts/DrawerAskAIContext'
import DrawerAskAIInput from './DrawerAskAIInput'
import DrawerAskAIBubble from './DrawerAskAIBubble'

const FooterContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: ${rem(12)} ${rem(24)} ${rem(16)};
  gap: ${rem(8)};
  pointer-events: none;

  > * {
    pointer-events: auto;
  }
`

const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${rem(8)};
  width: 100%;
  max-width: ${rem(652)};
`

interface Props {
  contextLabel: string
  isOpen: boolean
  /** Formatted hotel details to include as context when asking from a hotel drawer. */
  hotelDetails?: string
}

function DrawerAskAIFooter({
  contextLabel,
  isOpen,
  hotelDetails,
}: Props) {
  const intl = useIntl()
  const { submitMessage, messages, isStreaming } = useDrawerAskAIChatState()

  const {
    handleSubmit,
    latestResponse,
    sessionHistory,
    isResponseStreaming,
    isWaitingForResponse,
    hasActiveSession,
  } = useDrawerAskAI({
    submitMessage,
    messages,
    isStreaming,
    contextLabel,
    isOpen,
    hotelDetails,
  })

  return (
    <FooterContainer>
      {hasActiveSession && (
        <ContentWrapper>
          <DrawerAskAIBubble
            latestResponse={latestResponse}
            sessionHistory={sessionHistory}
            isResponseStreaming={isResponseStreaming}
            isWaitingForResponse={isWaitingForResponse}
          />
        </ContentWrapper>
      )}
      <DrawerAskAIInput
        onSubmit={handleSubmit}
        disabled={isStreaming}
        placeholder={intl.formatMessage(
          {
            id: 'johNJoOJenxVY0dTszC9',
            defaultMessage: 'Ask me anything about {contextLabel}',
            description: 'Placeholder text for AI assistant input field with context about current item',
          },
          { contextLabel },
        )}
        hasActiveSession={hasActiveSession}
      />
    </FooterContainer>
  )
}

DrawerAskAIFooter.displayName = 'DrawerAskAIFooter'

export default DrawerAskAIFooter
